<template>
  <div class="standardTabs OC_B_RETURN_ORDER_WARNING">
    <Tabs value="1"
          type="card"
          :animated="false"
          @on-click="tabClickFun">
      <!-- 退款又发货 -->
      <TabPane :label="t('退款又发货')" name="1" />
      <!-- 退款未入库 -->
      <TabPane :label="t('退款未入库')" name="2" />
      <!-- 退款后换货发货 -->
      <TabPane :label="t('退款后换货发货')" name="3" />
      <!-- 急速退款发货预警 -->
      <TabPane :label="t('急速退款发货预警')" name="4" />
    </Tabs>
  </div>
</template>

<script>
export default {
  name: "returnOrderWarning",
  data() {
    return {
      warningType: '1' // 异常类型
    }
  },
  mounted() {
    this.$nextTick(() => {
      $('.standardTabs').parent().parent().attr('style', 'order: 3 !important')
    })
  },
  methods: {
    tabClickFun(name) {
      console.log(name, '---name')
      this.warningType = name
      this.$parent.$parent.$parent.searchEvent()
    }
  }
}
</script>
<style lang="less" scoped>
.standardTabs.OC_B_RETURN_ORDER_WARNING {
  /deep/.ark-tabs-bar {
    margin-bottom: 0 !important;
  }
}
</style>
